import { render, staticRenderFns } from "./Abuse.vue?vue&type=template&id=4f5471f2&"
import script from "./Abuse.vue?vue&type=script&lang=js&"
export * from "./Abuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports